import {Route, Routes} from 'react-router-dom'
import {Registration} from './components/Registration'
import {ForgotPassword} from './components/ForgotPassword'
import {Login} from './components/Login'
import {AuthLayout} from './AuthLayout'
import { ChangePassword } from './components/ChangePassword'
import ResetLinkPage from './components/ResetLinkMessagePage'
import { AccountVerify } from './components/AccountVerify'
import { ResendVerification } from './components/ResendVerification'

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path='login' element={<Login />} />
      <Route path='registration' element={<Registration />} />
      <Route path='forgot-password' element={<ForgotPassword />} />
      <Route path='change-password' element={<ChangePassword />} />
      <Route path='reset-link-sent' element={<ResetLinkPage />} />
      <Route path='account-verify' element={<AccountVerify />} />
      <Route path='resend-verification' element={<ResendVerification />} />


      <Route index element={<Login />} />
    </Route>
  </Routes>
)

export {AuthPage}
